import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { CCompanyInfoViewModel } from '../models/commonInformation.models/commonInformation.model';
import { CDateTimeViewModel } from '../models/commonInformation.models/dateTimeViewModel.model';

@Injectable()
export class CommonInformationService {
    constructor(private http: HttpClient) {

    }

    GetInfo() {
        return this.http.get<CCompanyInfoViewModel>(API_ServerAddress + 'api/CommonInformations/CompanyInfo');
    }
    NowDateInfo() {
        return this.http.get<CDateTimeViewModel>(API_ServerAddress + 'api/CommonInformations/NowDateInfo');
    }
}